<template>
  <v-container v-editable="blok" class="mt-0 mb-5 py-0">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="10" md="8" >
          <img src="@/assets/logo_mini_light.svg" alt="">
      </v-col>
      <v-col cols="12" sm="10" md="8" >
          <p>{{blok.description}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["blok"]
};
</script>

<style lang="scss" scoped>
@import "./TextBox.scss";
</style>